<template>
	<div class="ContactAddress" v-if="contactAddress">
		<v-label>{{ title }} <span class="error-text">({{ $t('text.required') }})</span></v-label>
		<TextField :title="$t('text.placeHolderAddress')"
			:error-messages="streetAddressErrors"
			@blur="autogeocode()"
			@update:modelValue="onUpdateStreetAddress"
			v-model="contactAddress.fields.streetAddress.de"
		/>
		<div style="display: flex; gap: 15px;">
			<TextField :title="$t('text.placeHolderPostCode')"
				style="flex-grow: 1;"
				:error-messages="zipCodeErrors"
				@blur="autogeocode()"
				@update:modelValue="onUpdateZipCode"
				v-model="contactAddress.fields.zipCode.de"
			/>
			<TextField :title="$t('text.placeHolderCityTown')"
				style="flex-grow: 1;"
				:error-messages="cityErrors"
				@blur="autogeocode()"
				@update:modelValue="onUpdateCity"
				v-model="contactAddress.fields.city.de"
			/>
		</div>
		<FieldWrap :title="$t('text.placeHolderCountry')">
			<!-- TODO: why is country not bound to .de? -->
			<v-select variant="outlined" density="compact" return-object
				style="margin-top: 3px;"
				hide-details
				:placeholder="$t('text.placeHolderCountry')"
				:error-messages="countryErrors"
				:items="countryNames"
				:item-title="item => item?.[selectedLocale] || $t('text.placeHolderCountry')"
				@update:modelValue="onUpdateCountry"
				v-model="contactAddress.fields.country"
			/>
		</FieldWrap>
		<LocationFieldOld ref="location"
			:value="location"
			:address="contactAddress"
			@changed="onUpdateLocation"
		/>
	</div>
</template>

<script>
import Common from '@/mixins/Common.vue'
import TextField from './TextField.vue'
import FieldWrap from './FieldWrap.vue'
import LocationFieldOld from './LocationFieldOld.vue'
import { ekLocation } from './LocationFieldOld.vue'

// ATT: "ek" == "ErrorKey"

export function ekContactAddress(value) {
	return ekStreetAddress(value.fields.streetAddress.de)
		|| ekZipCode(value.fields.zipCode.de)
		|| ekCity(value.fields.city.de)
		|| ekCountry(value.fields.country)
}

function ekStreetAddress(value) {
	if (value?.length == 0) return 'text.businessAddressRequiredError'
}

function ekZipCode(value) {
	if (value?.length == 0) return 'text.businessAddressRequiredError'
}

function ekCity(value) {
	if (value?.length == 0) return 'text.businessAddressRequiredError'
}

function ekCountry(value) {
	//console.log('ekCountry', value?.de)
	if (!value || Object.keys(value).length == 0 || value?.de?.length === 0) return 'text.businessAddressRequiredError'
}

export default {
	name: 'ContactAddress',
	mixins: [ Common ],
	components: { TextField, FieldWrap, LocationFieldOld },
	props: {
		title: String,
		contactAddress: Object,
		location: Object,
	},
	data: () => ({
		countries: [],
		streetAddressErrors: [],
		postalCodeErrors: [],
		cityErrors: [],
		countryErrors: [],
		zipCodeErrors: [],
		initialContactAddress: null,
		initialLocation: null,
	}),
	computed: {
		countryNames() {
			return this.countries.map(item => item.name)
		},
	},
	watch: {
		'contactAddress.fields.country': function (newVal, oldVal){
			this.validateCountry()
		}
	},
	methods: {
		async autogeocode() {
			await this.$refs.location.autogeocode()
		},
		getMessages(key) {
			if (!key) return []
			return [ this.$t[key] ]
		},
		validateAllFields() {
			const locationError = ekLocation(this.location)
			return ekContactAddress(this.contactAddress)
		},
		validateStreetAddress(n) {
			this.streetAddressErrors = this.getMessages(ekStreetAddress(n))
		},
		validateZipCode(n) {
			this.zipCodeErrors = this.getMessages(ekZipCode(n))
		},
		validateCity(n) {
			// HACK: i dont know why, but initially city is validated, but country not, so i force it here
			this.validateCountry()
			this.cityErrors = this.getMessages(ekCity(n))
		},
		validateCountry() {
			this.countryErrors = this.getMessages(ekCountry(this.contactAddress?.fields?.country))
		},
		checkContactAddressFieldHasChanged(fieldName, newValue) {
			return this.initialContactAddress.fields?.[fieldName]?.de !== newValue
		},
		onUpdateStreetAddress(n) {
			this.validateStreetAddress(n)
			this.$emit('changed', this.checkContactAddressFieldHasChanged('streetAddress', n))
		},
		onUpdateZipCode(n) {
			this.validateZipCode(n)
			this.$emit('changed', this.checkContactAddressFieldHasChanged('zipCode', n))
		},
		onUpdateCity(n) {
			this.validateCity(n)
			this.$emit('changed', this.checkContactAddressFieldHasChanged('city', n))
		},
		onUpdateCountry(n) {
			this.$emit('changed', this.checkContactAddressFieldHasChanged('country', n))
		},
		onUpdateLocation(n) {
			this.$emit('changed', JSON.stringify(this.initialLocation) !== JSON.stringify(n))
		}
	},
	created() {
		this.initialContactAddress = JSON.parse(JSON.stringify(this.contactAddress))
		this.initialLocation = JSON.parse(JSON.stringify(this.location, (_, value) => (typeof value === 'number' ? String(value) : value)))
		this.countries = this.getCountries()
	},
}
</script>

<style scoped>
.ContactAddress { }
</style>